import { createElement } from 'react';
import { CLEAR_BUTTONS_REGISTRY } from './clear-button-registry';
import { ClearButtonBaseProps, ClearButtonType } from './types';

export function useRenderClearButton(
  type: ClearButtonType,
  props: ClearButtonBaseProps
) {
  const component = CLEAR_BUTTONS_REGISTRY.get(type);
  return component && createElement(component, props);
}
